import { Vue } from 'vue-property-decorator'

const eventbus = new Vue()

export default eventbus
